// extracted by mini-css-extract-plugin
export default {"switcherWrapper":"Switcher_switcherWrapper__uXDWt","input":"Switcher_input__gsQWT","switcher":"Switcher_switcher__lgIF-"};